var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var DocumentAPI = /** @class */ (function (_super) {
    __extends(DocumentAPI, _super);
    function DocumentAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentAPI.prototype.list = function (props) { return this.fetcher.get("/api/documents", props); };
    DocumentAPI.prototype.update = function (props) { return this.fetcher.post("/api/document", props); };
    DocumentAPI.prototype.remove = function (list) { return this.fetcher.post("/api/document/remove", { ids: list }); };
    DocumentAPI.prototype.upload = function (props, onProgress) { debugger; return this.fetcher.postFormDataWithProgress("/api/document/upload", { info: JSON.stringify({ project: props.project, updateFor: props.updateFor }), file: props.file }, onProgress); };
    DocumentAPI.prototype.downloadLink = function (file, revision) { var rev = revision === undefined ? "" : "&revision=" + revision; return "/api/document/download?type=inline&file=" + file + rev; };
    DocumentAPI.prototype.download = function (file) { window.open("/api/document/download?type=inline&file=" + file, "_blank"); };
    DocumentAPI.prototype.downloadURL = function (file) { return "/api/file?id=".concat(file, "&type=inline"); };
    return DocumentAPI;
}(SubAPI));
export { DocumentAPI };
